import { fetchLocalContentLanguages } from './fetchLocalContentLanguages';
import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../../../config';
import { useTranslation } from 'react-i18next';

export const LOCAL_CONTENT_LANGUAGES_QUERY_KEY = 'localContentLanguages';

export const useLocalContentLanguages = () => {
    const { t } = useTranslation();

    return useQuery(
        [LOCAL_CONTENT_LANGUAGES_QUERY_KEY],
        () =>
            fetchLocalContentLanguages().then(
                languages =>
                    languages.map(x => ({
                        name: t(`filters:language.${x.name}`, x.name),
                        code: x.code
                    })) ?? []
            ),
        {
            ...GlobalReactQueryOptions
        }
    );
};
